import React, { FC, useContext } from 'react';
import { PageNav } from '../../components/page-nav/PageNav';
import { LawyerAbout } from './about/LawyerAbout';
import { LawyerClients } from './clients/LawyerClients';
import { LawyerDisclaimer } from './disclaimer/LawyerDisclaimer';
import { LawyerEducation } from './education/LawyerEducation';
import { LawyerHeader } from './header/LawyerHeader';
import { LawyerDescription } from './description/LawyerDescription';
import { lawyerNav } from './lawyerNav';
import { LawyerTopDecisions } from './decisions/LawyerTopDecisions';
import { LawyerPayment } from './payment/LawyerPayment';
import { LawyerRetired } from './retired/LawyerRetired';
import { LawyerSpecialisations } from './specialisations/LawyerSpecialisations';
import { LawyerUpload } from './upload/LawyerUpload';
import { LawyerCases } from './cases/LawyerCases';
import { Sticker } from '../../components/sticker/Sticker';
import { LawyerSubHeader } from './sub-header/LawyerSubHeader';
import { LawyerMobileBar } from './sub-header/LawyerMobileBar';
import { CustomToastContainer } from '../../components/toaster/CustomToastContainer';
import { LawyerCommentaries } from './lawyer-commentaries/LawyerCommentaries';
import { PageContainer } from '../../components/page-container/PageContainer';
import { Page, PageLeft, PageCenter } from '../../components/page/Page';
import { UserContext } from '../../user/UserContext';
import { LawyerContext } from './LawyerContext';

export const LawyerMain: FC = () => {
  const {
    currentUser: { isSnapshotsCrawler },
  } = useContext(UserContext);
  const { lawyerIsCurrentUser } = useContext(LawyerContext);

  const isFollowButtonPresent = !lawyerIsCurrentUser;
  return (
    <>
      {isFollowButtonPresent ? (
        <Sticker margin="lawyer-sub-header" anchor="add-watcher-lawyer">
          {({ isVisible }) => <LawyerSubHeader isVisible={isVisible} />}
        </Sticker>
      ) : (
        <LawyerSubHeader isVisible />
      )}
      <CustomToastContainer />
      <div className="entity">
        <PageContainer>
          <Page>
            <PageLeft>
              <PageNav outline={lawyerNav} newNav />
            </PageLeft>
            <PageCenter>
              <LawyerHeader isFollowButtonPresent={isFollowButtonPresent} />
              <LawyerRetired />
              <LawyerSpecialisations />
              <LawyerDescription />
              <LawyerEducation />
              <LawyerCommentaries />
              <LawyerAbout />
              <LawyerPayment />
              <LawyerTopDecisions dontShowHref={isSnapshotsCrawler} />
              <LawyerCases dontShowHref={isSnapshotsCrawler} />
              <LawyerClients />
              <LawyerUpload />
              <LawyerDisclaimer />
            </PageCenter>
            {isFollowButtonPresent ? (
              <Sticker anchor="add-watcher-lawyer">
                {({ isVisible }) => <LawyerMobileBar isVisible={isVisible} />}
              </Sticker>
            ) : (
              <LawyerMobileBar isVisible />
            )}
          </Page>
        </PageContainer>
      </div>
    </>
  );
};
